import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="6"
        viewBox="0 0 10 6"
      >
        <path
          fill="#FFF"
          fillOpacity=".5"
          fillRule="evenodd"
          d="M1.64.203l2.88 2.94a.67.67 0 0 0 .96 0L8.36.203a.67.67 0 0 1 .961 0l.48.49c.265.27.265.71 0 .98L5.96 5.594c-.53.541-1.39.541-1.92 0L.199 1.674a.705.705 0 0 1 0-.981l.48-.49a.67.67 0 0 1 .96 0"
        />
      </svg>
    )
  }
}

export default SvgFile
